import { Badge, CrossIcon, Pane, Text } from "evergreen-ui";
import React, { useEffect, useState } from "react";
import { FaCheck, FaRegMoneyBillAlt } from "react-icons/fa";
import { dates } from "./datanurse";
import StatusRegister_0 from "./StatusRegister/StatusRegister_0";
import StatusRegister_1 from "./StatusRegister/StatusRegister_1";
import StatusRegister_2 from "./StatusRegister/StatusRegister_2";
import StatusRegister_3 from "./StatusRegister/StatusRegister_3";
import StatusRegister_4 from "./StatusRegister/StatusRegister_4";
import StatusRegister_41 from "./StatusRegister/StatusRegister_41";
import StatusRegister_5 from "./StatusRegister/StatusRegister_5";
import StatusRegister_6 from "./StatusRegister/StatusRegister_6";
import StatusRegister_9 from "./StatusRegister/StatusRegister_9";

function StatusDisplayNew({ data }) {
  const [DataRegister, setDataRegister] = useState();
  const [ListMajor, setListMajor] = useState([]);
  const GetListMajor = (DATAREGISTER) => {
    const List = [];
    DATAREGISTER.forEach((items) => {
      if (items.Major1_MAJOR_ID !== null) {
        List.push({
          Major_LEVEL_OPEN_ID: items.Major1_LEVEL_OPEN_ID,
          Major_LEVEL_OPEN_NAME: items.Major1_LEVEL_OPEN_NAME,
          Major_MAJOR_CLASSROOM: items.Major1_MAJOR_CLASSROOM,
          Major_MAJOR_CLASSROOM2: items.Major1_MAJOR_CLASSROOM2,
          Major_MAJOR_CLASSROOM3: items.Major1_MAJOR_CLASSROOM3,
          Major_MAJOR_ID: items.Major1_MAJOR_ID,
          Major_MAJOR_NAME: items.Major1_MAJOR_NAME,
          Major_course_year: items.Major1_course_year,
          Major_course_year_id: items.Major1_course_year_id,
          Major_course_year_name: items.Major1_course_year_name,
          Major_faculty_name: items.Major1_faculty_name,
          REGISTER_TYPE_ID: items.REGISTER_TYPE_ID,
          REGISTER_ID: items.REGISTER_ID,
          ROB_ID: items.ROB_ID,
          REGISTER_STATUS_BILL_ROBFULL_BOOK: items.REGISTER_STATUS_BILL_ROBFULL_BOOK,
          REGISTER_STATUS_BILL_ROB1_BOOK: items.REGISTER_STATUS_BILL_ROB1_BOOK,
          REGISTER_STATUS_BILL_ROB1_NO: items.REGISTER_STATUS_BILL_ROB1_NO,
          REGISTER_STATUS_BILL_ROB1_COUNT: items.REGISTER_STATUS_BILL_ROB1_COUNT,
          REGISTER_STATUS_BILL_ROB2_BOOK: items.REGISTER_STATUS_BILL_ROB2_BOOK,
          REGISTER_STATUS_BILL_ROB2_NO: items.REGISTER_STATUS_BILL_ROB2_NO,
          REGISTER_STATUS_BILL_ROB2_COUNT: items.REGISTER_STATUS_BILL_ROB2_COUNT,
          ROB_YEAR: items.ROB_YEAR,
          REGISTER_STATUS_BILL_ROBFULL_NO: items.REGISTER_STATUS_BILL_ROBFULL_NO,
          REGISTER_STATUS_BILL_ROBFULL_COUNT: items.REGISTER_STATUS_BILL_ROBFULL_COUNT,
          CITIZEN: items.CITIZENT_LOGIN,
          REGISTER_STATUS: items.REGISTER_STATUS,
        });
      }
      if (items.Major2_MAJOR_ID !== null) {
        List.push({
          Major_LEVEL_OPEN_ID: items.Major2_LEVEL_OPEN_ID,
          Major_LEVEL_OPEN_NAME: items.Major2_LEVEL_OPEN_NAME,
          Major_MAJOR_CLASSROOM: items.Major2_MAJOR_CLASSROOM,
          Major_MAJOR_CLASSROOM2: items.Major2_MAJOR_CLASSROOM2,
          Major_MAJOR_CLASSROOM3: items.Major2_MAJOR_CLASSROOM3,
          Major_MAJOR_ID: items.Major2_MAJOR_ID,
          Major_MAJOR_NAME: items.Major2_MAJOR_NAME,
          Major_course_year: items.Major2_course_year,
          Major_course_year_id: items.Major2_course_year_id,
          Major_course_year_name: items.Major2_course_year_name,
          Major_faculty_name: items.Major2_faculty_name,
          REGISTER_TYPE_ID: items.REGISTER_TYPE_ID,
          REGISTER_ID: items.REGISTER_ID,
          ROB_ID: items.ROB_ID,
          REGISTER_STATUS_BILL_ROBFULL_BOOK: items.REGISTER_STATUS_BILL_ROBFULL_BOOK,
          REGISTER_STATUS_BILL_ROB1_BOOK: items.REGISTER_STATUS_BILL_ROB1_BOOK,
          REGISTER_STATUS_BILL_ROB1_NO: items.REGISTER_STATUS_BILL_ROB1_NO,
          REGISTER_STATUS_BILL_ROB1_COUNT: items.REGISTER_STATUS_BILL_ROB1_COUNT,
          REGISTER_STATUS_BILL_ROB2_BOOK: items.REGISTER_STATUS_BILL_ROB2_BOOK,
          REGISTER_STATUS_BILL_ROB2_NO: items.REGISTER_STATUS_BILL_ROB2_NO,
          REGISTER_STATUS_BILL_ROB2_COUNT: items.REGISTER_STATUS_BILL_ROB2_COUNT,
          ROB_YEAR: items.ROB_YEAR,
          REGISTER_STATUS_BILL_ROBFULL_NO: items.REGISTER_STATUS_BILL_ROBFULL_NO,
          REGISTER_STATUS_BILL_ROBFULL_COUNT: items.REGISTER_STATUS_BILL_ROBFULL_COUNT,
          CITIZEN: items.CITIZENT_LOGIN,
          REGISTER_STATUS: items.REGISTER_STATUS,
        });
      }
      if (items.Major3_MAJOR_ID !== null) {
        List.push({
          Major_LEVEL_OPEN_ID: items.Major3_LEVEL_OPEN_ID,
          Major_LEVEL_OPEN_NAME: items.Major3_LEVEL_OPEN_NAME,
          Major_MAJOR_CLASSROOM: items.Major3_MAJOR_CLASSROOM,
          Major_MAJOR_CLASSROOM2: items.Major3_MAJOR_CLASSROOM2,
          Major_MAJOR_CLASSROOM3: items.Major3_MAJOR_CLASSROOM3,
          Major_MAJOR_ID: items.Major3_MAJOR_ID,
          Major_MAJOR_NAME: items.Major3_MAJOR_NAME,
          Major_course_year: items.Major3_course_year,
          Major_course_year_id: items.Major3_course_year_id,
          Major_course_year_name: items.Major3_course_year_name,
          Major_faculty_name: items.Major3_faculty_name,
          REGISTER_TYPE_ID: items.REGISTER_TYPE_ID,
          REGISTER_ID: items.REGISTER_ID,
          ROB_ID: items.ROB_ID,
          REGISTER_STATUS_BILL_ROBFULL_BOOK: items.REGISTER_STATUS_BILL_ROBFULL_BOOK,
          REGISTER_STATUS_BILL_ROB1_BOOK: items.REGISTER_STATUS_BILL_ROB1_BOOK,
          REGISTER_STATUS_BILL_ROB1_NO: items.REGISTER_STATUS_BILL_ROB1_NO,
          REGISTER_STATUS_BILL_ROB1_COUNT: items.REGISTER_STATUS_BILL_ROB1_COUNT,
          REGISTER_STATUS_BILL_ROB2_BOOK: items.REGISTER_STATUS_BILL_ROB2_BOOK,
          REGISTER_STATUS_BILL_ROB2_NO: items.REGISTER_STATUS_BILL_ROB2_NO,
          REGISTER_STATUS_BILL_ROB2_COUNT: items.REGISTER_STATUS_BILL_ROB2_COUNT,
          ROB_YEAR: items.ROB_YEAR,
          REGISTER_STATUS_BILL_ROBFULL_NO: items.REGISTER_STATUS_BILL_ROBFULL_NO,
          REGISTER_STATUS_BILL_ROBFULL_COUNT: items.REGISTER_STATUS_BILL_ROBFULL_COUNT,
          CITIZEN: items.CITIZENT_LOGIN,
          REGISTER_STATUS: items.REGISTER_STATUS,
        });
      }
    });
    setListMajor(List);
  };

  useEffect(() => {
    const DATAREGISTER = Array(data);
    setDataRegister(DATAREGISTER);
    GetListMajor(DATAREGISTER);
    AllowPayNurse("159");
  }, [data]);
  const AllowPayNurse = (ROB) => {
    let [day, month, year] = dates;
    if (parseInt(year) > 2400) {
      year = (parseInt(year) - 543).toString();
    }
    const textDate = `${month}/${day}/${year} 23:59`;
    const enddate = new Date(textDate);
    const datenow = new Date();
    if (datenow > enddate) {
      console.log("มากกว่า");
      return true;
    } else {
      console.log("น้อยกว่า");
      return false;
    }
  };
  const ShowListTo = () => {
    const textDate = `08/18/2025 18:00`;
    const start = new Date(textDate);
    const datenow = new Date();
    if (datenow > start) {
      return true;
    } else {
      return false;
    }
  };

  const validCodes = [
    "1101",
    "1102",
    "1103",
    "1106",
    "1110",
    "1207",
    "1208",
    "1301",
    "1302",
    "1304",
    "1310",
  ];


  function renderStatusUI(status) {
    switch (status) {
      case "0":
        return <StatusRegister_0 />;
      case "1":
        return <StatusRegister_1 />;
      case "2":
        return <StatusRegister_2 />;
      case "3":
        return <StatusRegister_3 />;

      case "4":
        return <StatusRegister_4 DataRegister={DataRegister} />;
      case "41":
        return <StatusRegister_41 DataRegister={DataRegister} />;
      case "5":
        return <StatusRegister_5 DataRegister={DataRegister} />;
      case "6":
        return <StatusRegister_6 DataRegister={DataRegister} />;
      case "9":
        return <StatusRegister_9 DataRegister={DataRegister} />;
      default:
        return <StatusRegister_0 />;
    }
  }


  return (
    <div>
      {Array.isArray(DataRegister) && DataRegister.length > 0 ? (
        <>
          {DataRegister.map((item, index) => (
            renderStatusUI(item.REGISTER_STATUS)
          ))}

          {DataRegister.map((item, index) => (

            item.REGISTER_STATUS === "0" || item.REGISTER_STATUS === "1" || item.REGISTER_STATUS === "3" ? (
              <Pane backgroundColor="white" padding={10} marginTop={10}>
                <Text
                  fontWeight={600}
                  fontFamily=""
                  fontSize={14}
                  paddingTop={5}
                  marginBottom={10}
                >
                  รายละเอียดที่สมัคร
                </Text>
                <Pane gap={10} flexDirection={"column"}>
                  {ListMajor.map((item, key) => (
                    <>
                      <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                        <Pane fontWeight={600}>
                          <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                            ลำดับที่ {key + 1}
                          </Text>
                          &nbsp; หลักสูตร
                          {item.Major_LEVEL_OPEN_NAME +
                            " " +
                            item.Major_course_year +
                            " ปี  " +
                            item.Major_MAJOR_ID +
                            " : สาขาวิชา" +
                            item.Major_MAJOR_NAME}
                        </Pane>
                        {DataRegister[0].REGISTER_STATUS === "0" ? (
                          <>
                            {key + 1 === 1 && (
                              <Text marginTop={10} marginLeft={15} className="text-warning">
                                รอการชำระเงินค่าสมัคร
                              </Text>
                            )}
                          </>
                        ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                          <>
                            {key + 1 === ListMajor.length ? (
                              <>
                                {/* <Text fontWeight={700} className="text-info">
                                  * รายละเอียดวันเวลาและสถานที่สอบสัมภาษณ์
                                </Text> */}
                                <Pane
                                  color="#ffffff"
                                  backgroundColor="#ff0000"
                                  height="100%"
                                  paddingY={4}
                                  paddingX={5}
                                  fontSize={16}
                                  fontFamily=""
                                  fontWeight={700}
                                  marginTop={10}
                                  display="flex" alignItems="center" justifyContent="center"
                                >
                                  <Text color="#ffffff" fontWeight={700}>
                                    ประกาศรายชื่อสอบสัมภาษณ์และพิมพ์ใบสมัคร วันที่ 16 มกราคม 2569 เวลา 18.00 น.
                                  </Text>
                                </Pane>

                                {/* 
                                  <Pane display="flex" flexDirection={"column"}>
                                  <div className="d-flex">
                                    <Text fontWeight={600}>รอประกาศรายชื่อสอบสัมภาษณ์และพิมพ์ใบสมัคร วันที่ 16 มกราคม 2569 เวลา 18.00 น.</Text>
                                  </div>
                                  <div className="d-flex">
                                    <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                    <div> {item.Major_MAJOR_CLASSROOM}</div>
                                  </div>
                                  <div className="d-flex">
                                    <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                    <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                  </div>
                                  <div className="d-flex">
                                    <Text fontWeight={600}>
                                      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                                      &nbsp;&nbsp; &nbsp;
                                    </Text>
                                    <div> {item.Major_MAJOR_CLASSROOM3} </div>
                                  </div>
                                  </Pane>
                                 */}

                              </>
                            ) : (
                              <></>
                            )}
                          </>
                        ) : (<></>)
                        }
                      </Pane>
                    </>
                  ))}
                </Pane>
              </Pane>
            ) : null

          ))}


        </>
      ) : (
        <Pane
          color="#ffffff"
          backgroundColor="#ff0000"
          height="100%"
          paddingY={4}
          paddingX={5}
          fontSize={16}
          fontFamily=""
          fontWeight={700}
          marginBottom={0}
          display="flex" alignItems="center" justifyContent="center"
        >
          <Text color="#ffffff" fontWeight={700}>
            <CrossIcon /> ไม่พบข้อมูล
          </Text>
        </Pane>
      )}
    </div>
  );
}

export default StatusDisplayNew;
